<template>
  <div>
    <BranchForm
      mode="edit"
      :loading="loading"
      :initialData="branchData"
      @submit="handleEdit"
    />

    <!-- Notification Toasts (Hidden in DOM, used by Toastify JS) -->
    <div id="success-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-9" />
      <div class="ml-4 mr-4">
        <div class="font-medium">{{ $t('branch.edited') }}!</div>
      </div>
    </div>
    <div id="failed-notification-content" class="toastify-content hidden flex">
      <XCircleIcon class="text-theme-6" />
      <div class="ml-4 mr-4">
        <div class="font-medium">{{ $t('branch.notEdited') }}!</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Toastify from 'toastify-js'
import branchApi from '../../services/branches/branch.api'
import BranchForm from '@/components/branches/BranchForm.vue'

const route = useRoute()
const router = useRouter()
const loading = ref(true)
const branchData = ref({})

onMounted(async () => {
  try {
    const response = await branchApi.getDetail(route.params.uuid)
    branchData.value = response.data
    loading.value = false
  } catch (error) {
    console.error('Load Error', error)
    // Handle load error toast here
    router.push({ name: 'side-menu-branches' })
  }
})

const handleEdit = async (payload) => {
  // We set loading true locally inside the form component via prop if desired,
  // but here we just wait for API
  try {
    await branchApi.editBranch(route.params.uuid, payload)

    Toastify({
      node: cash('#success-notification-content').clone().removeClass('hidden')[0],
      duration: 5000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()

    router.push({ name: 'side-menu-branches' })
  } catch (error) {
    console.error('Save Error', error)
    Toastify({
      node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
      duration: 10000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()
  }
}
</script>
